/**
 * @generated SignedSource<<2bab1ccf6f96c3e519d1a700f646a064>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DialogAddCandidates_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CandidateSelectField_query">;
  readonly " $fragmentType": "DialogAddCandidates_query";
};
export type DialogAddCandidates_query$key = {
  readonly " $data"?: DialogAddCandidates_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"DialogAddCandidates_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DialogAddCandidates_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CandidateSelectField_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "2bd19c61c531760b3f6eff158e19270a";

export default node;
